
<span *ngIf="publicationsCount == 0" title="No hay publicaciones vigentes"><i class="fa-light fa-mailbox fa-lg" ></i></span>

<div *ngIf="publicationsCount>0" class="dropdown publicationContainer">
<div #dropdownPublications data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" id="dropdownPublications" (click)="saveSeen($event)">
  <span  *ngIf="newPublications && clickCount == 0" class="circle"></span>
  <span >
    <i class="fa-light fa-mailbox fa-lg notificationIcon"></i>
  </span>
</div>

  <div class="dropdown-menu " aria-labelledby="dropdownPublications" id="dropMenuContainerPublications">
    <div class="trianglePublications"></div>
    <div [ngClass]="{ boardContainer: publicationsCount>1, boardContainerOnePub: publicationsCount == 1 }">
      <div class="publicationItemsContainer">
        <div *ngFor="let publication of publications" class="publicationItem">
          <div class="dotContainer">
            <span *ngIf="!viewedPublication(publication.id) && clickCount < 2"  class="circlePublication"></span>
          </div>
          <div class="inLine">
            <div>
              <i *ngIf="publication.publicationCategory.slug != 'ANNOUNCEMENT'; else kastorLogo"
                 class="fa {{publication.publicationCategory.icon}} fa-3x publicationIcon "
                 aria-hidden="true"></i>
                 <ng-template #kastorLogo>
                  <img class="imgKastorLogo" src="assets/img/iso-k-solid.svg" >
                 </ng-template>
            </div>
            <div class="textContent">
              {{publication.content}}
            </div>
          </div>
          <div *ngIf="publication.link && publication.link_text" class="callToAction">
            <a href="{{publication.link}}" target="_blank" (click)="saveClick(publication.id)">{{publication.link_text}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/layout/publications/publications.component.html